import { render } from "./MaintenancePage.vue?vue&type=template&id=ba044416&scoped=true"
const script = {}

import "./MaintenancePage.vue?vue&type=style&index=0&id=ba044416&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba044416"]])

export default __exports__